import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-x4 sm:mb-x6" }
const _hoisted_2 = {
  key: 0,
  class: "mb-x4 flex justify-start sm:justify-center"
}
const _hoisted_3 = {
  key: 1,
  class: "mb-x4"
}
const _hoisted_4 = { class: "flex justify-center items-center" }
const _hoisted_5 = {
  key: 0,
  class: "mr-x2 sm:mr-x6"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["title"]

import PdfLinkIconAndLabel from '@/shared/navigation/pdf-link/PdfLinkIconAndLabel.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import { computed, ref } from 'vue';
import BaseDialog from '@/shared/dialog/BaseDialog.vue';
import { Form } from 'vee-validate';
import ConfirmationButton from '@/shared/form/ConfirmationButton.vue';
import PrinterSelector from '@/storecontext/shared/printers/PrinterSelector.vue';
import authStore from '@/shared/auth/auth.store';
import InputRadio from '@/shared/form/InputRadio.vue';
import { ProductClientService } from '@/types/productServerApi';
import utilities from '@/shared/utilities.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductFactSheetDownload',
  props: {
    sku: null
  },
  setup(__props: any) {

const props = __props as {
    sku: string
}



const labels = useBlockLabels();
const showPrintOrPdfDialog = ref(false);
const isSignedInAsStore = computed(() => authStore.isSignedInAsStore);
const isPreSale = ref(false);
const generatingPdf = ref(false);

const downloadPdf = async() => {
    generatingPdf.value = true;
    try {
        const pdfBlob = await ProductClientService.downloadProductFactSheet(
            props.sku,
            isPreSale.value,
            undefined,
            undefined,
            { responseType: 'blob' },
        );
        utilities.downloadBlob(pdfBlob, `${props.sku}-fact-sheet.pdf`);
        generatingPdf.value = false;
    } catch (err) {
        generatingPdf.value = false;
    }
};

const submit = async({ printer }): Promise<void> => {
    await ProductClientService.printProductFactSheet(props.sku, printer, isPreSale.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BaseDialog, {
      "is-open": showPrintOrPdfDialog.value,
      class: "fixed inset-x-0 p-x3 sm:p-30 mx-auto mt-x4 z-1 text-center bg-white sm:relative sm:inset-auto w-screen-90 sm:h-auto sm:w-screen-80 md:px-x5 md:pb-x3 md:max-w-700",
      onClose: _cache[2] || (_cache[2] = ($event: any) => (showPrintOrPdfDialog.value = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("h1", _hoisted_1, _toDisplayString(_unref(labels).productFactSheetDialogHeading), 1),
        (_unref(isSignedInAsStore))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", null, [
                _createVNode(InputRadio, {
                  modelValue: isPreSale.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isPreSale).value = $event)),
                  class: "mb-x2",
                  name: "isPreSale",
                  value: true,
                  label: _unref(labels).productFactSheetPrintOption1
                }, null, 8, ["modelValue", "label"]),
                _createVNode(InputRadio, {
                  modelValue: isPreSale.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isPreSale).value = $event)),
                  name: "isPreSale",
                  value: false,
                  label: _unref(labels).productFactSheetPrintOption2
                }, null, 8, ["modelValue", "label"])
              ])
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(labels).productFactSheetGenerateInfoText), 1)),
        _createElementVNode("div", _hoisted_4, [
          (_unref(isSignedInAsStore))
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_unref(Form), {
                  class: "flex",
                  onSubmit: submit
                }, {
                  default: _withCtx(({ isSubmitting }) => [
                    _createVNode(PrinterSelector, {
                      label: _unref(labels).printerSelect,
                      "use-printer-name": true,
                      class: "mr-x2 mt-2"
                    }, null, 8, ["label"]),
                    _createVNode(ConfirmationButton, {
                      class: "c-button c-button--primary",
                      confirm: isSubmitting,
                      text: _unref(labels).productFactSheetPrintButtonText,
                      "confirm-min-duration": 2500,
                      "confirmation-text": _unref(labels).productFactSheetPrintPending
                    }, null, 8, ["confirm", "text", "confirmation-text"])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "c-button c-button--primary",
            disabled: generatingPdf.value,
            onClick: downloadPdf
          }, _toDisplayString(generatingPdf.value ? _unref(labels).productFactSheetGeneratingPdf : _unref(labels).productFactSheetGenerateButtonText), 9, _hoisted_6)
        ])
      ]),
      _: 1
    }, 8, ["is-open"]),
    _createElementVNode("button", {
      class: "text-left",
      title: _unref(labels).productFactSheetDownloadsLinkText,
      onClick: _cache[3] || (_cache[3] = ($event: any) => (showPrintOrPdfDialog.value = true))
    }, [
      _createVNode(PdfLinkIconAndLabel, {
        label: _unref(labels).productFactSheetDownloadsLinkText
      }, null, 8, ["label"])
    ], 8, _hoisted_7)
  ], 64))
}
}

})